import { render } from "./PerformanceProgress.vue?vue&type=template&id=458a607e&ts=true"
import script from "./PerformanceProgress.vue?vue&type=script&lang=ts"
export * from "./PerformanceProgress.vue?vue&type=script&lang=ts"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__